import {
  Box,
  Center,
  Container,
  Flex,
  Heading,
  Image,
  Link,
  SimpleGrid,
  Spinner,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useQuery } from "react-query";
import { truncate } from "../../../core/utils";
import { getNews } from "../../../services/newsApi";
import { getArticleLink } from "../articleLink";
import Article from "../components/Article";

const News = () => {
  const { data, isLoading } = useQuery(["news"], () => getNews());

  if (isLoading) {
    return (
      <Center height="80vh">
        <Spinner color="red" size="lg" />
      </Center>
    );
  }

  const RedwingPost = ({ post }) => (
    <Box
      mr={{ base: 0, md: 6, lg: 6 }}
      mb={{ base: 6, md: 0, lg: 0 }}
      flex={{ base: "none", md: "4" }}
      width="100%"
      borderRadius="lg"
      overflow="hidden"
      bg="gray.700"
    >
      <Link href={getArticleLink(post)}>
        <Image
          src={
            post && post.bookClubId
              ? post.image
              : post && post.readingOrder && post.readingOrder.thumbnail
              ? post.readingOrder.thumbnail
              : post.image
          }
          alt={post.title}
          objectFit="cover"
        />
      </Link>
      <Box p="6">
        <Text fontSize="small" color="red.400">
          {post.source}
        </Text>
        <Link href={getArticleLink(post)}>
          <Heading as="h4" size="md" mb="3">
            {post.title}
          </Heading>
        </Link>
        <Box as="p" color="gray.400" fontSize="sm">
          {truncate(post.description, 100)}
        </Box>
        <Text pt="1" fontSize="small" color="gray.200">
          {post.date}
        </Text>
      </Box>
    </Box>
  );

  return (
    <VStack>
      <Container maxW="container.lg">
        <Heading as="h2" my="6">
          Latest news
        </Heading>
        {data?.data && data?.data?.length > 1 && (
          <Flex
            color="white"
            mt="6"
            flexDirection={{ base: "column", md: "row" }}
          >
            <RedwingPost post={data.data[0]} />
            <Box
              flex={{ base: "none", md: "3" }}
              width="100%"
              borderRadius="lg"
              overflow="hidden"
              bg="gray.700"
            >
              <Link href={getArticleLink(data.data[1])}>
                <Image
                  src={data.data[1].image}
                  alt={data.data[1].title}
                  minH={"300px"}
                  objectFit="cover"
                />
              </Link>
              <Box p="6">
                <Text fontSize="small" color="red.400">
                  {data.data[1].source}
                </Text>
                <Link href={getArticleLink(data.data[1])}>
                  <Heading as="h4" size="md" mb="3">
                    {data.data[1].title}
                  </Heading>
                </Link>
                <Box as="p" color="gray.400" fontSize="sm">
                  {truncate(data.data[1].description, 100)}
                </Box>
                <Text pt="1" fontSize="small" color="gray.200">
                  {data.data[1].date}
                </Text>
              </Box>
            </Box>
          </Flex>
        )}

        {data?.data && data?.data?.length > 2 && (
          <SimpleGrid my="6" columns={[1, null, 2, 3]} spacing={6}>
            {data.data.slice(2).map((article, index) => (
              <Article key={index} article={article} />
            ))}
          </SimpleGrid>
        )}
      </Container>
    </VStack>
  );
};

export default News;
